import PropTypes from 'prop-types';
import ResourceFormProxy from "classes/ResourceFormProxy";

const formContextShape = PropTypes.instanceOf(ResourceFormProxy);

export default formContextShape;


// WEBPACK FOOTER //
// ./public/components/forms/ResourceFormContextShape.js